import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    // Brand tím Vui Để Học — đồng bộ với app iOS/Android, logo & charts (#7C5CFC).
    // 500 = màu chính (light), 400 = sáng hơn cho dark mode, 600 = hover.
    brand: {
      50: "#F4F0FF",
      100: "#E7DEFF",
      200: "#CFBEFF",
      300: "#B79DFF",
      400: "#9D78FF",
      500: "#7C5CFC",
      600: "#6846E6",
      700: "#5537C4",
      800: "#3F2996",
      900: "#2B1C68",
    },
    brandScheme: {
      50: "#F4F0FF",
      100: "#E7DEFF",
      200: "#CFBEFF",
      300: "#B79DFF",
      400: "#9D78FF",
      500: "#7C5CFC",
      600: "#6846E6",
      700: "#5537C4",
      800: "#3F2996",
      900: "#2B1C68",
    },
    brandTabs: {
      50: "#F4F0FF",
      100: "#E7DEFF",
      200: "#CFBEFF",
      300: "#B79DFF",
      400: "#9D78FF",
      500: "#7C5CFC",
      600: "#6846E6",
      700: "#5537C4",
      800: "#3F2996",
      900: "#2B1C68",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  // Token theo ngữ cảnh: tự đổi light/dark. Dùng thay cho whiteAlpha.300 (vốn tàng hình ở light).
  semanticTokens: {
    colors: {
      // Đường kẻ / viền phân cách — thấy rõ ở CẢ light lẫn dark.
      line: { default: "#E6E2F3", _dark: "#2A2350" },
      cardBorder: { default: "#EAE7F5", _dark: "#2A2350" },
      // Nền ô con dịu (mini-stat, hàng bảng, item).
      softBg: { default: "#FBFAFF", _dark: "#1E1840" },
      // Nền hover cho hàng/list — hiện rõ ở cả 2 mode.
      hoverBg: { default: "#F4F1FD", _dark: "rgba(255,255,255,0.06)" },
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "Be Vietnam Pro",
        letterSpacing: "-0.5px",
      },
      input: {
        color: mode("gray.700", "white")(props),
      },
      textarea: {
        color: mode("gray.700", "white")(props),
      },
      select: {
        color: mode("gray.700", "white")(props),
      },
      html: {
        fontFamily: "Be Vietnam Pro",
      },
    }),
  },
};
